module.exports = __webpack_public_path__ + "media/images/browsers/chromium-5bef651634e15deeb10473979342806e.svg";